(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('AccountService', AccountService);

    AccountService.$inject = ['$resource'];

    function AccountService($resource) {

        var accountService = {};
        var accountResource = $resource('/account/:action');
        var userResource = $resource('/user/:action');

        accountService.getCurrentAccount = function () {
            return userResource.get({
                action: 'whoami'
            }).$promise;
        };

        accountService.updateCurrentAccount = function (basicSettings) {
            return userResource.save({
                action: 'update'
            }, basicSettings).$promise;
        };

        accountService.getSupportedCids = function () {
            return accountResource.query({
                action: 'getsupportedcids'
            }).$promise;
        };


        return accountService;
    }

})();
